import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

const KEY_POLOTNO_STICKERPACKS = "polotno.stickerpacks";

type Params = Parameters<typeof ApiSmpArtGallery.Polotno.stickerpacks>[0];
type Response = Await<ReturnType<typeof ApiSmpArtGallery.Polotno.stickerpacks>>;

export const useQueryPolotnoStickerpacks = (
  params?: Params,
  options?: Omit<
    UseInfiniteQueryOptions<Response>,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) =>
  useInfiniteQuery<Response>(
    [KEY_POLOTNO_STICKERPACKS, params],
    ({ pageParam }) =>
      ApiSmpArtGallery.Polotno.stickerpacks(pageParam || params),
    {
      ...options,
      getNextPageParam: (response) =>
        response.next
          ? Object.fromEntries(new URL(response.next).searchParams)
          : undefined,
    },
  );

useQueryPolotnoStickerpacks.KEY = KEY_POLOTNO_STICKERPACKS;
